import { Alert, Button, Snackbar } from "@mui/material";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useNavigate } from "react-router-dom";
import { AUTHORIZATION, HOSTNAME_PATHI } from "../../../common/constants";
import HorizontalNav from "../../../components/HorizontalNav";
import authTokenForAPI from "../../../utils/authTokenForAPI";
import {
  primaryColor,
  secondaryColor,
  ternaryColor,
} from "../../../utils/styleObjs";

const ListShabadMedia = () => {
  const [listShabadMedia, setListShabadMedia] = useState([]);
  const [snack, setSnack] = useState({
    open: false,
    severity: "success",
    msg: "",
  });
  const history = useNavigate();
  useEffect(() => {
    trackPromise(
      axios
        .get(`${HOSTNAME_PATHI}/shabadMedias`, {
          headers: { [AUTHORIZATION]: authTokenForAPI() },
        })
        .then((res) => {
          console.log(res);
          setListShabadMedia(res.data.map((v) => ({ ...v, id: v.ref })));
        })
    );
  }, []);
  const navLinks = [{ key: 0, label: "Home", path: "/home" }];

  const columns = [
    { field: "ref", headerName: "ID" },
    { field: "shabadMediaGroup", headerName: "Media name", width: 150 },
  ];

  return (
    <>
      <Snackbar
        open={snack.open}
        autoHideDuration={6000}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
      <HorizontalNav navLinks={navLinks} pageName="Media" />
      <Box display={"flex"} justifyContent={"space-between"}>
        <h2>Media</h2>
        <Button
          variant="contained"
          sx={{
            margin: "20px",
            float: "right",
          }}
          onClick={() => history("/shabadMedia/add")}
        >
          Add Media
        </Button>
      </Box>
      <div>
        <DataGrid
          density="compact"
          showCellRightBorder
          autoHeight
          sx={{
            borderColor: primaryColor,
            backgroundColor: ternaryColor,
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: secondaryColor,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: primaryColor,
              color: "white",
              fontWeight: "600",

              "& .MuiSvgIcon-root": {
                color: "white",
              },
            },
            "& .MuiDataGrid-cellCheckbox .MuiSvgIcon-root": {
              color: primaryColor,
            },
          }}
          onRowClick={(v) => {
            console.log(v);
            history(`/shabadMedia/edit/${v.id}`);
          }}
          rows={listShabadMedia}
          columns={columns}
        />
      </div>
    </>
  );
};
export default ListShabadMedia;
